export function filterPizzasTomate(map) {
  return map.filter((value) => {
    return value.Base_Tomate;
  });
}
